import axios from 'axios';

export const defaultState = {
  canceledSettlements: [],
  canceledSettlementHistory: [],
};

export const mutations = {
  SET_CANCELED_DATA(context, data) {
    context.canceledSettlements = data;
  },
  SET_CANCELED_SETTLEMENT_HISTORY_DATA(context, data) {
    context.canceledSettlementHistory = data;
  },
};

export const getters = {
  getCanceledSettlements: context => context.canceledSettlements,
  getCanceledSettlementsHistory: context => context.canceledSettlementHistory,
};

export const actions = {

  fetchCanceledSettlements({ commit }, params) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/cancel?key=${params ? params.key : ''}&value=${params ? params.value : ''}`)
      .then(({ data }) => {
        commit('SET_CANCELED_DATA', data.data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_CANCELED_DATA', []);

        return Promise.reject(error);
      });
  },

  fetchCanceledSettlementHistory({ commit }, settlementId) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/cancel/${settlementId}`)
      .then(({ data }) => {
        commit('SET_CANCELED_SETTLEMENT_HISTORY_DATA', data.data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_CANCELED_SETTLEMENT_HISTORY_DATA', []);

        return Promise.reject(error);
      });
  },

};

const canceledSettlementsStore = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default canceledSettlementsStore;



// WEBPACK FOOTER //
// ./src/store/settlements/canceledSettlementsStore.js